import Seo from "@/components/feature/Seo";
import Hero from "@/pages/home/components/Hero";
import ReversalTracker from "@/pages/home/components/ReversalTracker";
import OfficialResponseFeed from "@/pages/home/components/OfficialResponseFeed";
import FactCheckStrip from "@/pages/home/components/FactCheckStrip";
import VerifyProcess from "@/pages/home/components/VerifyProcess";
import GuideTeaser from "@/pages/home/components/GuideTeaser";
import HomeFaq from "@/pages/home/components/HomeFaq";
import SubmitCta from "@/pages/home/components/SubmitCta";
import { cases } from "@/mocks/cases";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";

export default function Home() {
  const visibleFaqs = faqs.slice(0, 5);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteInfo.fullName,
      url: siteInfo.url,
      description: siteInfo.description,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${siteInfo.url}/cases?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteInfo.name,
      url: siteInfo.url,
      description: siteInfo.description,
      email: siteInfo.email,
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "最新反转追踪案例",
      itemListElement: cases.slice(0, 4).map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
        url: `${siteInfo.url}/cases/${item.slug}`,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: visibleFaqs.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer,
        },
      })),
    },
  ];

  return (
    <>
      <Seo
        title="社会爆料核验｜社会爆料反转、官方回应，真相核验一站直达 - 棱镜求证"
        description="棱镜求证追踪社会爆料反转与官方回应，核验辟谣信息真假，提供求证视角与真相梳理。汇总辟谣动态与官方通报，帮你快速看清事件全貌，持续更新中。"
        keywords="社会爆料,社会爆料反转,社会爆料官方回应,社会爆料辟谣,真相核验"
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <ReversalTracker />
      <OfficialResponseFeed />
      <FactCheckStrip />
      <VerifyProcess />
      <GuideTeaser />
      <HomeFaq />
      <SubmitCta />
    </>
  );
}